import type { InternationalizedText } from '@cobliteam/dashboard/src/dashboardDef';

/**
 * Helper function to get the appropriate language text from internationalized objects
 * @param text - The text object that can be either a string or InternationalizedText
 * @param language - The current language code (e.g., 'pt-BR', 'en-US')
 * @returns The text in the appropriate language, or empty string if no text is provided
 */
export const getTextForLanguage = (text: string | InternationalizedText | undefined, language: string): string => {
  if (!text) return '';
  if (typeof text === 'string') return text;
  return language === 'en-US' ? text['en-US'] : text['pt-BR'];
};
